import { Badge } from "@/components/ui/badge";
import type { DeskSuggestionStatus } from "@/lib/types/desk-suggestions";

const STATUS_CONFIG: Record<
  DeskSuggestionStatus,
  {
    label: string;
    variant: "secondary" | "destructive" | "outline" | "positive" | "warning";
    className?: string;
  }
> = {
  pending: { label: "Pending", variant: "outline" },
  running: {
    label: "Running",
    variant: "warning",
    className: "animate-pulse motion-reduce:animate-none",
  },
  completed: { label: "Completed", variant: "positive" },
  failed: { label: "Failed", variant: "destructive" },
  applied: { label: "Applied", variant: "secondary" },
};

export function RunStatusBadge({ status }: { status: DeskSuggestionStatus }) {
  // eslint-disable-next-line security/detect-object-injection
  const config = STATUS_CONFIG[status];
  return (
    <Badge variant={config.variant} className={config.className}>
      {config.label}
    </Badge>
  );
}
